<template>
  <div class="d-flex flex-row flex-md-column align-items-center bg-light bgColor">
    <div class="d-flex justify-content-center mr-4 mr-md-0">
      <b-avatar variant="info" :src="user.avatar" class="user-avatar"></b-avatar>
    </div>

    <div>
      <div class="my-2">
        <div class="names">
          <div>
            {{ user.last_name }}
            <span class="d-md-none">,</span>
          </div>
          <div>{{ isParent ? (user.gender === 'M' ? 'Père' : 'Mère') : user.classroom.name }}</div>
        </div>
      </div>

      <div class="d-flex justify-content-center">
        <input type="file" class="d-none" ref="updateImgInput" @change="imgUpdate()" accept="image/*">
        <b-button squared variant="outline-secondary" class="mr-2 btn-font-size" @click="$refs.updateImgInput.click()">
          Changer la photo
        </b-button>

        <b-button
          squared
          variant="outline-secondary"
          class="btn-font-size"
          @click="showModalPseudo"
        >Charger le pdeudo
        </b-button>
      </div>

      <div class="my-2">
        <b-button block
          squared
          variant="outline-secondary"
          class="mx-0 mx-md-auto btn-font-size"
          @click="showModalPassword"
        >Charger le mot de passe
        </b-button>
      </div>

      <b-modal ref="pseudo" hide-footer title="Edit pseudo">
        <div class="d-flex my-4">
          <label class="mr-2">Pseudo</label>
          <b-form-input v-model="pseudo" type="text" required placeholder="entrez le pseudo"></b-form-input>
        </div>

        <div class="d-flex justify-content-between">
          <b-button squared variant="primary" @click="hideModalPseudo">Cancel</b-button>
          <b-button squared variant="primary" @click="submitPseudo">Submit</b-button>
        </div>
      </b-modal>

      <!-- ============================================================================================
      ======================+++++++++++b-modal for password ++++++++++++===============================
      =================================================================================================-->
      <b-modal ref="password" hide-footer title="Edit password">
        <b-row class="d-flex my-4">
          <b-col><label>Old password</label></b-col>
          <b-col cols="8">
            <b-form-input v-model="oldPass" type="password" required placeholder="password"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="d-flex my-4">
          <b-col><label>New password</label></b-col>
          <b-col cols="8">
            <b-form-input v-model="newPass" type="password" required placeholder="password"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="d-flex my-4">
          <b-col><label>Confirm password</label></b-col>
          <b-col cols="8">
            <b-form-input v-model="confirmPass" type="password" required placeholder="password"></b-form-input>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-between">
          <b-button squared variant="primary" @click="hideModalPassword">Cancel</b-button>
          <b-button squared variant="primary" @click="submitPassword">Submit</b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    user: {required: true},
  },
  data() {
    return {
      pseudo: '',
      oldPass: null,
      newPass: null,
      confirmPass: null,
      image: null
    };
  },
  computed: {
    isParent() {
      return this.user.roles.indexOf("parent") >= 0;
    },
  },
  methods: {
    showModalPseudo() {
      this.$refs["pseudo"].show();
    },
    hideModalPseudo() {
      this.$refs["pseudo"].hide();
    },
    toggleModalPseudo() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["pseudo"].toggle("#toggle-btn");
    },
    showModalPassword() {
      this.$refs["password"].show();
      console.log(this.user)
    },
    hideModalPassword() {
      this.$refs["password"].hide();
    },
    toggleModalPassword() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["password"].toggle("#toggle-btn");
    },
    submitPassword() {
      if (this.newPass === this.confirmPass && this.newPass != null) {
        this.$refs["password"].toggle("#toggle-btn");
        const data = {
          'newpassword': this.newPass, 'oldpassword': this.oldPass
        }
        axios.post(`/user/${this.user.id}/password`, data)
          .then((response) => {
            console.log(response.data)
            this.$toast.fire({
              title: 'Le mot de passe a été modifié',
              icon: 'success'
            })
          })
          .catch((error) => {
            console.log(error)
            alert(error)
          })
      } else {
        alert("either your confirmed password does not match your newpassword or you are try to submit an empty field")
      }

    },
    submitPseudo() {
      if (this.pseudo != '') {
        this.$refs["pseudo"].toggle("#toggle-btn");
        const data = {
          'pseudo': this.pseudo
        }
        axios.post(`/user/${this.user.id}/pseudo`, data)
          .then((response) => {
            console.log(response.data)
          })
          .catch((error) => {
            console.log(error)
            alert(error)
          })
      }

    },
    imgUpdate() {
      this.image = this.$refs.updateImgInput.files[0];
      const data = new FormData()
      data.append("avatar", this.image)
      console.log(this.image);
      axios.post(`/user/${this.user.id}/avatar`, data)
        .then((response) => {
          this.user.avatar = response.data.avatar
          console.log(response.data)
          this.$toast.fire({
            title: 'La photo de profil a été modifiée',
            icon: 'success'
          })
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
};
</script>

<style lang="scss" scoped>
.names {
  display: flex;
  flex-direction: column;
  text-align: center;
  @include md() {
    flex-direction: row;
  }
}

.nameFonction div {
  width: fit-content;
}

.btn-font-size {
  font-size: 11px;
}

.user-avatar {
  width: 120px !important;
  height: 120px !important;
}
@media all and (max-width: 768px){
  .user-avatar {
    width: 70px !important;
    height: 70px !important;
  }
}

@media (min-width: 768px) {
  .bgColor {
    background: transparent !important;
  }
}
</style>
